/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Tab_CommunityInputs */



/**
* | output |
* | --- |
* | "Community" |
*
* @param {Community_Tab_CommunityInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_tab_community = /** @type {((inputs?: Community_Tab_CommunityInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Tab_CommunityInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Communauté")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comunidad")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Comunidade")
	if (locale === "it") return /** @type {LocalizedString} */ ("Comunità")
	return /** @type {LocalizedString} */ ("Community")
});